import { Aggregator, AggregatorImageProfile } from '../types';

const STORAGE_KEY = 'aggregator:imageProfiles';

const safeParse = (value: string | null) => {
  if (!value) return {};
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === 'object' && parsed !== null ? parsed as Record<string, AggregatorImageProfile> : {};
  } catch {
    return {};
  }
};

const persist = (map: Record<string, AggregatorImageProfile>) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore storage failures */
  }
};

export const loadProfiles = (): Record<string, AggregatorImageProfile> => {
  if (typeof localStorage === 'undefined') return {};
  return safeParse(localStorage.getItem(STORAGE_KEY));
};

export const saveProfile = (id: string, profile: AggregatorImageProfile | null | undefined) => {
  if (!id || typeof localStorage === 'undefined') return;
  const map = loadProfiles();
  if (profile) {
    map[id] = profile;
  } else {
    delete map[id];
  }
  persist(map);
};

export const mergeAggregatorProfiles = (aggregators: Aggregator[]): Aggregator[] => {
  const profiles = loadProfiles();
  return (aggregators || []).map((agg) => ({
    ...agg,
    imageProfile: profiles[agg.id] || agg.imageProfile,
  }));
};
